/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { tap, map } from 'rxjs/operators';
import { XmlparseService } from '../xml/xmlparse.service';
import { AlertService } from "../../services/alert/alert.service";
import { IceTypes } from 'projects/icemedx-lib/src/models/icetypes';
import { LoginService } from '../../login/login.service';
import { basecode } from '../../models/ehr/subs/basecode';

declare var require: any;
@Injectable()

export class MedicalcodesService extends XmlparseService {

    constructor(private http: HttpClient,
      private alertSvc: AlertService, private loginSvc: LoginService) {
        super(alertSvc, loginSvc);
    }

  public getCodes(codeTable: string, codeKey: string, code: string, keyword: string, domainAccount: string = "", domainType: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone) {
        let currentEnv: any = require("../../../../../env.json").currentEnv;
        let envs: any = require("../../../../../env.json").environments;
        if (!envs || !currentEnv) throw "Domain service is not configured.";

        let obj_code = null,
            url = envs[currentEnv].icemedx_api + "/codes/default.aspx?table=" + codeTable;

        if (codeKey != null && codeKey.length > 0) {
            url = url + "&key=" + codeKey;
        }
        else {
            url = url + "&key=";
        }

        if (code != null && code.length > 0) {
            url = url + "&code=" + code;
        }
        else {
            url = url + "&code=";
        }

        if (keyword != null && keyword.length > 0) {
            url = url + "&keyword=" + keyword;
        }
        else {
            url = url + "&keyword=";
        }

        if (domainAccount != null && domainAccount.length > 0) {
            url = url + "&domain=" + domainAccount;
        }
        else {
            url = url + "&domain=";
        }

        if (domainType != null && domainType.toString().length > 0) {
            url = url + "&domaintype=" + domainType.toString();
        }
        else {
            url = url + "&domaintype=";
        }

        try {
            if ((keyword == null || keyword.length == 0) && domainAccount == null) {
                let storgeddata = sessionStorage.getItem("code." + codeTable + "." + code);

                try {
                    obj_code = JSON.parse(storgeddata);
                }
                catch (parse_e) {
                    obj_code = null;
                    console.log(parse_e);
                }

                if (obj_code != null) {
                    return obj_code;
                }
            }

            return this.http.get(url, { responseType: 'text' }).map(
                response => {
                    try {
                        switch (codeTable) {
                            case "NDCCODE_ALTERNATIVES":
                            case "NDCCODE_IDENTICAL":
                            case "NDCCODE_PREFERENCES":
                            case "NDCCODE_INTERACTIONS":
                            case "SideEffects": {
                                codeTable = "NDCCODE";
                                break;
                            }
                            case "NDCCODE_INFORMATION": {
                              break;
                            }
                        }

                        var obj_tempCode = null;
                        if (codeTable === "" || codeTable === null || codeTable === undefined) {
                          obj_tempCode = this.geticexdocumentobjects(response, ["NDCCODE", "ICDCODE", "CPTCODE", "BENEFIT_CODE", "MANAGEMENT_GUIDELINE"]);
                        }
                        else if (codeTable === "NDCCODE_INFORMATION") {
                          obj_tempCode = this.geticexdocumentobjects(response, ["DRUGCOMPOSITION", "SIDEEFFECT", "INGREDIENT"]);
                        } else {
                            obj_tempCode = this.geticexdocumentobjects(response, [codeTable]);
                        }

                        if (obj_tempCode != null) {
                          obj_tempCode.sort(function (a, b) {
                            if (a.title == null) {
                              if (a.description == null) return 0;
                              return a.description.localeCompare(b.description);
                            }
                            return a.title.localeCompare(b.title);
                          });

                          try {
                            let storgeddata = JSON.stringify(obj_tempCode);
                            sessionStorage.setItem("code." + codeTable + "." + code, storgeddata);
                          }
                          catch (stringify_e) {
                            console.log(stringify_e);
                          }
                        }
                      return obj_tempCode;
                    } catch (e) {
                        console.log(e);
                    }
                },
                error => this.parseLogReport(url, error));
        }
        catch (e) {
            console.log(e);
        }
    }

  public static getPregnancyOutcomeList(): any[] {
    let list = [
      { value: "O00", name: "Ectopic pregnancy" },
      { value: "O02", name: "Other abnormal products of conception" },
      { value: "O03", name: "Spontaneous abortion" },
      { value: "O04", name: "Medical abortion" },
      { value: "O05", name: "Other abortion" },
      { value: "O06", name: "Unspecified abortion" },
      { value: "O07", name: "Failed attempted abortion" },
      { value: "O70", name: "Perineal laceration during delivery" },
      { value: "O60", name: "Preterm delivery" },
      { value: "O63", name: "Long labour" },
      { value: "O69", name: "Labour and delivery complicated by umbilical cord complications" },
      { value: "O70", name: "Perineal laceration during delivery" },
      { value: "O75", name: "Other complications of labour and delivery, NEC" },
      { value: "Z37", name: "Outcome of delivery" },
      { value: "Z37.0", name: "Single live birth" },
      { value: "Z37.1", name: "Single stillbirth" },
      { value: "Z37.2", name: "Twins, both liveborn" },
      { value: "Z37.3", name: "Twins, one liveborn and one stillborn" },
      { value: "Z37.4", name: "Twins, both stillborn" },
      { value: "Z37.5", name: "Other multiple births, all liveborn" },
      { value: "Z37.6", name: "Other multiple births, some liveborn" },
      { value: "Z37.7", name: "Other multiple births, all stillborn" },
      { value: "Z37.9", name: "Outcome of delivery, unspecified" },
      { value: "O80", name: "Single spontaneous delivery" },
      { value: "O80.0", name: "Spontaneous vertex delivery" },
      { value: "O80.1", name: "Spontaneous breech delivery" },
      { value: "O80.8", name: "Other single spontaneous delivery" },
      { value: "O80.9", name: "Single spontaneous delivery, unspecified" },
      { value: "O81", name: "Single delivery by forceps and vacuum extractor" },
      { value: "O81.0", name: "Low forceps delivery" },
      { value: "O81.2", name: "Mid-cavity forceps with rotation" },
      { value: "O81.3", name: "Other and unspecified forceps delivery" },
      { value: "O81.4", name: "Vacuum extractor delivery" },
      { value: "O81.5", name: "Delivery by combination of forceps and vacuum extractor" },
      { value: "O82", name: "Single delivery by caesarean section" },
      { value: "O82.0", name: "Delivery by elective caesarean section" },
      { value: "O82.1", name: "Delivery by emergency caesarean section" },
      { value: "O82.2", name: "Delivery by caesarean hysterectomy" },
      { value: "O82.8", name: "Other single delivery by caesarean section" },
      { value: "O82.9", name: "Delivery by caesarean section, unspecified" },
      { value: "P95", name: "Fetal death of unspecified cause" },
      { value: "P03.8", name: "Fetus and newborn affected by other specified complications of labour and delivery" },
      { value: "O94", name: "Sequelae of complication of pregnancy, childbirth and the puerperium" },
      { value: "P01.6", name: "Fetus and newborn affected by maternal death" },
      { value: "O36.4", name: "Maternal care for intrauterine death" },
      { value: "O95", name: "Obstetric death of unspecified cause" },
      { value: "O31.2", name: "Continuing pregnancy after intrauterine death of one fetus or more" },
      { value: "O96", name: "Death from any obstetric cause occurring more than 42 days but less than one year after delivery" },
      { value: "O96.0", name: "Death from direct obstetric cause" },
      { value: "O96.1", name: "Death from indirect obstetric cause" },
      { value: "O96.9", name: "Death from unspecified obstetric cause" },
      { value: "O97", name: "Death from sequelae of direct obstetric causes" },
      { value: "O97.0", name: "Death from sequelae of direct obstetric cause" },
      { value: "O97.1", name: "Death from sequelae of indirect obstetric cause" },
      { value: "O97.9", name: "Death from sequelae of obstetric cause, unspecified" },
    ];
    list.sort(function (a, b) { return a.name.localeCompare(b.name) });
    return list;
  }

  public static getAddressTypeList(): any[] {
    let list = [
      { value: IceTypes.addresstype.atHome, name: "Home" },
      { value: IceTypes.addresstype.atMailing, name: "Mailing" },
      { value: IceTypes.addresstype.atWork, name: "Work" },
      { value: IceTypes.addresstype.atOffice, name: "Office" },
      { value: IceTypes.addresstype.atCorporate, name: "Corporate" },
      ];
    list.sort(function (a, b) { return a.name.localeCompare(b.name) });
    return list;
  }

  public static getContactMethodList(): any[] {
    let list = [
      { value: "TE", name: "Phone" },
      { value: "EM", name: "Email" },
      { value: "FX", name: "Fax" },
    ];
    list.sort(function (a, b) { return a.name.localeCompare(b.name) });
    return list;
  }

  public static getContactTypeList(): any[] {
    let list = [
      { value: IceTypes.contacttype.ctHome, name: "Home" },
      { value: IceTypes.contacttype.ctWork, name: "Work" },
      { value: IceTypes.contacttype.ctOffice, name: "Office" },
      { value: IceTypes.contacttype.ctCorporate, name: "Corporate" },
      { value: IceTypes.contacttype.ctCell, name: "Cell" },
      { value: IceTypes.contacttype.ctOther, name: "Other" },
      { value: IceTypes.contacttype.ctFax, name: "Fax" },
    ];
    list.sort(function (a, b) { return a.name.localeCompare(b.name) });
    return list;
  }

  public static getMedicalCodeTypeList(): any[] {
    let list = [
      { value: "CPT", name: "Cognitive Processing Therapy (CPT-Code)" },
      { value: "NDC", name: "National Drug Code (NDC)" },
      { value: "HCPCS", name: "Durable Medical Equipment (DME or HCPCS)" },
      { value: "", name: "Other Code" },
    ];
    list.sort(function (a, b) { return a.name.localeCompare(b.name) });
    return list;
  }

  public static getAlertType(type: IceTypes.ALERTTYPE): string {
    if (type == null)
      return "";

    try {
      switch (type) {
        case IceTypes.ALERTTYPE.alertAdverseInteraction:
          return "Adverse Interaction";
        case IceTypes.ALERTTYPE.alertDiagnosis:
          return "Diagnosis";
        case IceTypes.ALERTTYPE.alertDiseaseManagement:
          return "Disease Management";
        case IceTypes.ALERTTYPE.alertMedication:
          return "Medication";
        case IceTypes.ALERTTYPE.alertNotification:
          return "Notification";
        case IceTypes.ALERTTYPE.alertOrder:
          return "Order";
        case IceTypes.ALERTTYPE.alertPreventiveManagement:
          return "Preventive Management";
        case IceTypes.ALERTTYPE.alertSystem:
          return "System";
        case IceTypes.ALERTTYPE.alertVitals:
          return "Vitals";
        case IceTypes.ALERTTYPE.alertWellnessManagement:
          return "Wellness Management";
        case IceTypes.ALERTTYPE.alertContraIndication:
          return "Contra-Indication";
        case IceTypes.ALERTTYPE.alertHealthLiteracy:
          return "Health Literacy";
        case IceTypes.ALERTTYPE.alertSurvey:
          return "Survey";
      }
    } catch (e) {
      console.error(e.message);
    }
    return "Unknown";
  }

  public static getSeverityType(type: IceTypes.severitytype): string {
    if (type == null)
      return;

    try {
      switch (type) {
        case IceTypes.severitytype.servTypeMild:
          return "Mild";
        case IceTypes.severitytype.servTypeIntensive:
          return "Diagnosis";
        case IceTypes.severitytype.servTypeCritical:
          return "Disease Management";
        case IceTypes.severitytype.servTypeNonCritical:
          return "Medication";
      }
    } catch (e) {
      console.error(e.message);
    }
    return "Unknown";
  }

  public static searchCodeByKeyword(codes: basecode[], keyword: string, options: any) {
    let searchResults: any[] = [];
    try {
      if (keyword == null || keyword.length == 0)
        return searchResults;

      let resultCodeField = "code";
      let resultTitleField = "title";

      var apdfields = [];
      if (options != null) {
        apdfields = options["appendfields"];
        if (apdfields == null)
          apdfields = [];

        if (options.resultCodeField != null && options.resultCodeField.length > 0) {
          resultCodeField = options.resultCodeField;
        }

        if (options.resultTitleField != null && options.resultTitleField.length > 0) {
          resultTitleField = options.resultTitleField;
        }
      }


      for (var ic = 0; ic < codes.length; ic++) {
        var cde = codes[ic];
        if (cde != null) {
          var title = cde["title"];
          var code = cde["code"];
          if (code == null || code == "0" || code.toLowerCase() == keyword.toLowerCase()) {
            if (cde["DITXML"] != null) {
              var dit = cde["DITXML"];
              if (dit != null && dit.length > 0) {
                var drgres = dit[0];
                if (drgres != null) {
                  var drglist = drgres["RXNSATLIST"];
                  if (drglist != null && drglist.length > 0) {
                    var drg = drglist[0];
                    if (drg != null && drg.atv != null) {
                      code = drg.atv;
                    }
                  }
                  else if (drgres["RXNCONSOLIST"] != null) {
                    drglist = drgres["RXNCONSOLIST"];
                    for (var idrg = 0; idrg < drglist.length; idrg++) {
                      var drg = drglist[idrg];
                      if (drg != null) {
                        if (title.length == 0)
                          title = cde["title"] = drg["str"];

                        let res = {};
                        res[resultCodeField] = "rxcui:" + drg["rxcui"] + "|" + "rxaui:" + drg["rxaui"];
                        res[resultTitleField] = drg["str"];
                        searchResults.push(res);
                      }
                    }
                  }
                  else if (drgres["DrugList"] != null) {
                    drglist = drgres["DrugList"];
                    for (var idrg = 0; idrg < drglist.length; idrg++) {
                      var drg = drglist[idrg];
                      if (drg != null) {
                        if (idrg == 0)
                          code = drg["drugcode"]; // replace first empty code

                        let res = {};
                        res[resultCodeField] = drg["drugcode"];
                        res[resultTitleField] = drg["drugname"];
                        searchResults.push(res);
                      }
                    }
                  }
                }
              }
            }
          }
        }

        if (apdfields.length > 0) {
          for (var iapd = 0; iapd < apdfields.length; iapd++) {
            var fld = apdfields[iapd];
            if (fld != null && fld["name"] != null) {
              var fname = fld["name"];
              var fval = cde[fname];
              if (fname == "formularystatus") {
                //fval = getformularystatus(fval);
              }

              if (fval != null && fval.length > 0 && title.indexOf(fval) == -1) {
                title = title + ", " + fval;
              }
            }
          }
        }

        let codeRes = {};
        codeRes[resultCodeField] = code;
        codeRes[resultTitleField] = title;
        searchResults.push(codeRes);
      }

    } catch (e) {
      console.log(e);
    }

    return searchResults;
  }

}
